// extracted by mini-css-extract-plugin
module.exports = {"legend":"f799e","fieldset":"_157ee","sending":"_59709","error-message":"c4841","errorMessage":"c4841"};